import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Spinner from 'app/common/components/spinner/Spinner';

const LoaderNoData = () => {
    const { t } = useTranslation('common');

    return <div className="nd-loader__no-data">{t('common:noResults')}</div>;
};

const Loader = ({ className, loading, children, noData }) => {
    const classes = classNames(className, 'nd-loader');

    if (loading) {
        return (
            <div className={classes}>
                <Spinner />
            </div>
        );
    } else if (noData) {
        return (
            <div className={classes}>
                <LoaderNoData />
            </div>
        );
    }

    return children || null;
};

Loader.propTypes = {
    loading: PropTypes.bool,
    noData: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node
};

Loader.defaultProps = {
    children: null
};

export default React.memo(Loader);
